import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared.module';
import { MaterialsCalculatorCmsComponent } from './materials-calculator-cms.component';
import { CmsMaterialCalculatorPageComponent } from './page/material-calculator-cms-page';

@NgModule({
    imports: [SharedModule, CommonModule],
    declarations: [MaterialsCalculatorCmsComponent, CmsMaterialCalculatorPageComponent],
    exports: [CmsMaterialCalculatorPageComponent]
})
export class MaterialsCalculatorModule {}
